import { useMediaQuery } from "react-responsive";
import { TO_SMALL } from "core/ui/breakpoints";
import BaseTable from "./BaseTable";
import BaseTableMobile from "./BaseTableMobile";
import { ColumnDef } from "types/common/Header";
import BaseTableLoader from "./BaseTableLoader";
import { ORDER_BY } from "pages/admin-app/adminapp.constants";

interface LoaderDimensions {
  mobile: { rows: number; columns: number };
  desktop: { rows: number; columns: number };
}

interface Props<T extends { id: number }> {
  headers: ColumnDef<T>[];
  data: T[];
  entityType: string;
  onDelete: (entityId: string) => void;
  sortBy: string;
  order: ORDER_BY;
  onSort: (key: string) => void;
  loading?: boolean;
  loaderDimensions: LoaderDimensions;
}

const EntitiesTable = <T extends { id: number }>({
  headers,
  data,
  entityType,
  onDelete,
  sortBy,
  order,
  onSort,
  loading,
  loaderDimensions,
}: Props<T>) => {
  const isMobile = useMediaQuery({ query: TO_SMALL });

  if (isMobile) {
    return loading ? (
      <BaseTableLoader
        rows={loaderDimensions.mobile.rows}
        columns={loaderDimensions.mobile.columns}
      />
    ) : (
      <BaseTableMobile
        headers={headers}
        data={data}
        entityType={entityType}
        onDelete={onDelete}
      />
    );
  }

  return loading ? (
    <BaseTableLoader
      rows={loaderDimensions.desktop.rows}
      columns={loaderDimensions.desktop.columns}
    />
  ) : (
    <BaseTable
      headers={headers}
      data={data}
      entityType={entityType}
      onDelete={onDelete}
      sortBy={sortBy}
      order={order}
      onSort={onSort}
    />
  );
};

export default EntitiesTable;
